import script from "./CreateUpdateShippingRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUpdateShippingRule.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUpdateShippingRule.vue?vue&type=style&index=0&id=22c13a9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c13a9a"]])

export default __exports__